import {useSelector} from "react-redux";
import React, {memo} from "react";
import { RowType } from "../../../../../containers/AppPage/Reports/AgedDetail/utils/RowType";
import FormatNumber from "../../../../FormatNumber";
import {Big} from "../../../../../redux/Transaction/calculation/helper";

function AmountDetail({ rowType, amount, baseAmount, currencySymbol }) {
    const baseCurrencySymbol = useSelector(state => (
        state.Report.reportData?.company?.currency_symbol || null
    ));

    switch (rowType) {
        case RowType.spacer:
        case RowType.heading:
            return null;
        case RowType.type_total:
        case RowType.category_total:
        case RowType.normal:
        default: {
            const bolded = [RowType.type_total, RowType.category_total].includes(rowType);
            const isZero = Big(amount).eq(0);

            const classNames = [
                'amount-container',
                'amount-container-aging',
            ];
            if (bolded)
                classNames.push('bolded');
            if (isZero && !bolded)
                classNames.push('zero-amt');

            const divs = [
                <div className={`${classNames.join(' ')} is-base-currency`} key="base-amount">
                    <div className="currency">
                        {baseCurrencySymbol}
                    </div>
                    <div className="value">
                        <FormatNumber amount={baseAmount || 0} />
                    </div>
                </div>,
            ];

            if (currencySymbol && currencySymbol !== baseCurrencySymbol) {
                divs.push(
                    <div className={classNames.join(' ')} key="amount">
                        <div className="currency">
                            {currencySymbol}
                        </div>
                        <div className="value">
                            <FormatNumber amount={amount} />
                        </div>
                    </div>,
                );
            }

            return divs;
        }
    }
}

export default memo(AmountDetail);
